import * as Cookies from 'js-cookie';

const $doc = $(document);
const $win = $(window);
const $subscribe = $('.js-subscribe');
const $popupSubscribe = $('.js-popup-subscribe');

// Popup Subscribe
$popupSubscribe.find('.js-btn-toggle').on('click', function(e) {
  Cookies.set('popup-subscribe', 'visible');
});

$doc.on('click', '.js-subscribe button', function() {
  $subscribe.removeClass('alt');
  $(this).closest('.js-subscribe').addClass('alt');
});

window.addEventListener("klaviyoForms", function(e) { 
  if (e.detail.type == 'submit') {
    $subscribe.addClass('success');
    Cookies.set('popup-subscribe', 'visible');
  }
});

$win.on('load', function() {
  if ($popupSubscribe.length && Cookies.get('popup-subscribe') != 'visible') {
    $popupSubscribe.addClass('expanded');
  };
});



// WEBPACK FOOTER //
// ../assets/js/subscribe.js